module.exports = __webpack_public_path__ + "static/media/bg_night.8bec163b.png";


//////////////////
// WEBPACK FOOTER
// ./src/flappybird/bg_night.png
// module id = 182
// module chunks = 0